import Router from "vue-router";
import Vue from "vue";
import Home from "../views/home/index.vue"
import Abount from "../views/abount/index.vue"
import News from "../views/news/index.vue"

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home,
      meta: {
        title: "深圳无忧软件开发工作室-武汉无忧小程序开发工作室-广州无忧app开发工作室",
        content: {
          keywords: '无忧开发工作室,深圳小程序开发,广州app开发,武汉软件开发',
          description: '深圳无忧软件开发工作室公司官网：https://wykf.axtsh.cn',
        },
      }
    },
    {
      path: "/abount",
      name: "Abount",
      component: Abount,
      meta: {
        title: "深圳无忧软件开发工作室-武汉无忧小程序开发工作室-广州无忧app开发工作室",
        content: {
          keywords: '无忧开发工作室,深圳小程序开发,广州app开发,武汉软件开发',
          description: '深圳无忧软件开发工作室公司官网：https://wykf.axtsh.cn',
        },
      }
    },
    {
      path: "/news",
      name: "News",
      component: News,
      meta: {
        title: "深圳无忧软件开发工作室-武汉无忧小程序开发工作室-广州无忧app开发工作室",
        content: {
          keywords: '无忧开发工作室,深圳小程序开发,广州app开发,武汉软件开发',
          description: '深圳无忧软件开发工作室公司官网：https://wykf.axtsh.cn',
        },
      }
    },
  ]
})

// 解决重复导航错误
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
    // 对于重复导航，可以选择刷新页面或什么都不做
    // 这里我们选择什么都不做，避免错误
    return err
  })
}

// 添加重复替换错误处理
const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject)
  }
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
    return err
  })
}

// 监听浏览器后退/前进按钮
window.addEventListener('popstate', () => {
  // 使用 replace 而不是 push 来避免重复导航错误
  router.replace(router.currentRoute.fullPath)
})

// 全局守卫
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  
  if (to.meta.content) {
    const head = document.getElementsByTagName('head')[0];
    
    // 删除现有名称为 "keywords" 和 "description" 的 meta 标签
    const existingKeywordsMeta = document.querySelector('meta[name="keywords"]');
    if (existingKeywordsMeta) {
      existingKeywordsMeta.remove();
    }
    
    const existingDescriptionMeta = document.querySelector('meta[name="description"]');
    if (existingDescriptionMeta) {
      existingDescriptionMeta.remove();
    }

    // 创建并设置新的关键词和描述 meta 标签
    const keywordsMeta = document.createElement('meta');
    keywordsMeta.setAttribute('name', 'keywords');
    keywordsMeta.setAttribute('content', to.meta.content.keywords);
    head.appendChild(keywordsMeta);

    const descriptionMeta = document.createElement('meta');
    descriptionMeta.setAttribute('name', 'description');
    descriptionMeta.setAttribute('content', to.meta.content.description);
    head.appendChild(descriptionMeta);
  }
  
  next();
})

// 添加全局后置钩子来处理重复导航
router.afterEach((to, from) => {
  // 可以在这里添加一些导航完成后的逻辑
})

export default router